export const formatCurrency = (cents) => {
  return `$${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatRent = (dollars) => {
  return `$${Number(dollars).toLocaleString('en-US')}/mo`;
};

export const formatDate = (date) => {
  if (!date) return 'Flexible';
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatTimeAgo = (date) => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return formatDate(date);
};

export const userTypeLabel = (type) => {
  const labels = {
    student: 'Student',
    high_school_senior: 'HS Senior',
    young_adult: 'Young Adult',
    landlord: 'Landlord',
  };
  return labels[type] || type;
};

export const petPolicyLabel = (policy) => {
  const labels = {
    no_pets: 'No Pets',
    cats_only: 'Cats Only',
    dogs_allowed: 'Dogs OK',
    all_pets: 'All Pets Welcome',
  };
  return labels[policy] || policy;
};

export const getPhotoUrl = (url) => {
  if (!url) return null;
  // Cloudinary URLs are already absolute https:// links — return as-is
  if (url.startsWith('http')) return url;
  // Old /uploads/ paths pointed to Railway's ephemeral disk (now gone) — treat as missing
  return null;
};
